import { render } from "./ShowDetails.vue?vue&type=template&id=1899ace2&scoped=true"
import script from "./ShowDetails.vue?vue&type=script&lang=js"
export * from "./ShowDetails.vue?vue&type=script&lang=js"

import "./ShowDetails.vue?vue&type=style&index=0&id=1899ace2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1899ace2"]])

export default __exports__